import { MonoTypeOperatorFunction } from "rxjs"
import { distinctUntilChanged } from "rxjs/operators"

export function deepDistinctUntilChanged<T>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
}
